import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "lucide-react";
import celiaPhotoAsset from "@/assets/celia-orange.png.asset.json";

const MEETING_URL = "https://meetings.hubspot.com/ombeline-d-arras";
const CELIA_PHOTO = celiaPhotoAsset.url;

interface CeliaContactPopoverProps {
  children: React.ReactNode;
  align?: "start" | "center" | "end";
}

const CeliaContactPopover: React.FC<CeliaContactPopoverProps> = ({
  children,
  align = "end",
}) => {
  return (
    <Popover>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        align={align}
        sideOffset={8}
        className="w-[320px] p-0 rounded-2xl border border-black/10 shadow-xl bg-white"
        style={{ zIndex: 100000 }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 p-4 border-b border-black/5">
          <img
            src={CELIA_PHOTO}
            alt="Ombeline"
            className="w-11 h-11 rounded-full object-cover"
          />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-[#111111] truncate">
              Ombeline
            </p>
            <p className="text-xs text-[#6b7280] truncate">Votre conseillère Orange Business</p>
          </div>
        </div>

        {/* Action */}
        <div className="p-3">
          <a
            href={MEETING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full inline-flex items-center justify-center gap-2 bg-[#C6E278] text-[#111111] text-sm font-semibold px-3 py-2.5 rounded-xl hover:opacity-90 transition-opacity"
          >
            <Calendar className="w-4 h-4" />
            Prendre rendez-vous
          </a>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default CeliaContactPopover;
